/**
 * Shared Sonner toaster — lives above Layout so logout → /login still shows toasts.
 */
import { Toaster } from 'sonner';

export function AppToaster() {
  return (
    <Toaster
      position="bottom-right"
      duration={4000}
      toastOptions={{
        style: {
          background: 'var(--tinta)',
          color: 'var(--papel)',
          border: '1px solid var(--tinta)',
          borderRadius: '10px',
          fontSize: '13px',
        },
      }}
    />
  );
}
